import { booleanAttribute, ChangeDetectionStrategy, Component, ElementRef, inject, input } from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { ChevronRight } from '../icon/icons';

/**
 * Fila que lleva a otra pantalla o dispara una acción: "Origen", "Usar mi ubicación". Lo que vaya antes
 * del texto (marcador, ícono) se proyecta con `uiRowStart`. Sin alturas fijas: crece con el texto.
 */
@Component({
  selector: 'button[uiActionRow], a[uiActionRow]',
  imports: [IconComponent],
  template: `
    <ng-content select="[uiRowStart]" />
    <span class="text">
      @if (eyebrow(); as eyebrowText) {
        <span class="eyebrow">{{ eyebrowText }}</span>
      }
      <span class="label">{{ label() }}</span>
      @if (meta(); as metaText) {
        <span class="meta">{{ metaText }}</span>
      }
    </span>
    @if (chevron()) {
      <ui-icon class="chevron" [icon]="chevronIcon" size="1rem" />
    }
  `,
  styleUrl: './action-row.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionRowComponent {
  readonly label = input.required<string>();
  readonly eyebrow = input<string>();
  readonly meta = input<string>();
  readonly chevron = input(true, { transform: booleanAttribute });

  protected readonly chevronIcon = ChevronRight;

  constructor() {
    const host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    if (host.tagName === 'BUTTON' && !host.hasAttribute('type')) host.setAttribute('type', 'button');
  }
}
